const DEBUG = false;

/*------------------------------------------------------------------
External libraries
------------------------------------------------------------------*/

import * as Sentry from '@sentry/browser';


/** 
 * DSN switcher based on window location 
 * @param {string} host 
 * @returns {string} DSN for the selected environment
 */
export const dsn = (host) => {
    switch (true) {
        case (host.includes('portal.spaceshipsrentals.co.nz')):
            return 'https://44e3788727f9e3cd7b34c158bddec687@o234140.ingest.us.sentry.io/4508090512900096';
        case (host.includes('drive.spaceshipsrentals.co.nz')):
            return 'https://e3e6d4aad6004a2690a88d7739e1bc28@o234140.ingest.sentry.io/6781936';
        case (host.includes('payment.spaceshipsrentals.co.nz')):
            return 'https://977ad05ade26419ca91c87ca628dc75d@o234140.ingest.sentry.io/6749546';
        case (host.includes('quote.spaceshipsrentals.co.nz')):
            return 'https://444a98ac581d4803aa8b97b2c0fdeb29@o234140.ingest.sentry.io/6749547';
        case (host.includes('payment.spaceshipsrentals.com.au')):
            return 'https://80767b0e5c5b4199bd9074ad81c962ff@o234140.ingest.sentry.io/6238163';
        case (host.includes('quote.spaceshipsrentals.com.au')):
            return 'https://fc1f557e175d4e929b95d227ca0e7ec0@o234140.ingest.sentry.io/6359019';
        case (host.includes('payment.spaceshipsrentals.co.uk')):
            return 'https://140fc79e435b4b819952485439a883ef@o234140.ingest.sentry.io/6270090';
        case (host.includes('quote.spaceshipsrentals.co.uk')):
            return 'https://6d6a9d4038da42019867d70465dcce40@o234140.ingest.sentry.io/6460406';
        default: return '';
    }
};


/**
 * Log an api error to the Sentry error reporting service
 * @param {string} name 
 * @param {object} error 
 */

export const error = (name, error) => {
    if (!DEBUG) {
        Sentry.getCurrentScope().setTag(error, JSON.stringify(error));
        Sentry.captureMessage(name, 'debug');
    }
};


/**
 * Initialise Sentry
*/

if (!DEBUG) {
    Sentry.init({ 
        dsn: dsn(window.location.host),
        integrations: [
            new Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        tracesSampleRate: 1.0
    });
}